document.querySelectorAll('[data-awol-video-reel]').forEach(function (root) {
  var video = root.querySelector('video');
  var toggle = root.querySelector('[data-awol-sound-toggle]');
  if (!video || !toggle) return;

  var mutedIcon = toggle.querySelector('[data-awol-icon-muted]');
  var unmutedIcon = toggle.querySelector('[data-awol-icon-unmuted]');

  function updateIcons() {
    var isMuted = video.muted;
    toggle.setAttribute('aria-pressed', String(!isMuted));
    toggle.setAttribute('aria-label', isMuted ? 'Activar sonido' : 'Silenciar');
    mutedIcon.hidden = !isMuted;
    unmutedIcon.hidden = isMuted;
  }

  function stopWatchingForFirstInteraction() {
    document.removeEventListener('click', handleFirstInteraction);
    document.removeEventListener('scroll', handleFirstInteraction);
    document.removeEventListener('keydown', handleFirstInteraction);
    document.removeEventListener('touchstart', handleFirstInteraction);
  }

  function handleFirstInteraction(event) {
    if (toggle.contains(event.target)) return;
    video.muted = false;
    updateIcons();
    stopWatchingForFirstInteraction();
  }

  toggle.addEventListener('click', function () {
    video.muted = !video.muted;
    updateIcons();
    stopWatchingForFirstInteraction();
  });

  document.addEventListener('click', handleFirstInteraction);
  document.addEventListener('scroll', handleFirstInteraction, { passive: true });
  document.addEventListener('keydown', handleFirstInteraction);
  document.addEventListener('touchstart', handleFirstInteraction, { passive: true });
});
